import service from './service'
const qs = require('qs');
let protocol = 'https';
let name = 'dingdangyou';
let suffix = 'cn';
if (process.env.NODE_ENV === 'production') {
  // 生产环境
  protocol = 'https:';
  name = 'dingdangyou';
  suffix = 'cn';
} else {
  // 开发环境
  // protocol = 'http:';
  // name = 'gamehl';
  // suffix = 'my';
  protocol = 'https:';
  name = 'dingdangyou';
  suffix = 'cn';
}

//安全中心发送验证码
const sendCode = `${protocol}//sdkapi.${name}.${suffix}/api/v1/securityLogin/send`
//安全中心登录
const centerLogin = `${protocol}//sdkapi.${name}.${suffix}/api/v1/securityLogin/signLogin`
//安全中心获取设备列表
const deviceList = `${protocol}//sdkapi.${name}.${suffix}/api/v1/deviceInfo/index`
//安全中心登录保护
const loginProtection = `${protocol}//sdkapi.${name}.${suffix}/api/v1/securityCenter/index`
//首页设备授权
const authorization = `${protocol}//sdkapi.${name}.${suffix}/api/v1/deviceState/index`
//首页设备列表
const indexdeviceList = `${protocol}//sdkapi.${name}.${suffix}/api/v1/deviceInfo/deviceList`
//小号设备锁定
const deviceLocking = `${protocol}//sdkapi.${name}.${suffix}/api/v1/deviceState/deviceLocking`
//首页设备开关
const deviceOperation = `${protocol}//sdkapi.${name}.${suffix}/api/v1/deviceState/deviceOperation`
//首页设备删除
const deleteDevice = `${protocol}//sdkapi.${name}.${suffix}/api/v1/deviceState/deviceDelete`

//首页tab栏
const boxTabindex = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/tab/index`
//首页精选和新游
const selectedGame = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/selectedGame/index`
//首页排行榜
const leaderboard = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/leaderboard/index`
//搜索
const homeSearch = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/homeSearch/index`
//游戏大厅游戏分类
const gameCategory = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/game/category`
//游戏大厅游戏列表
const gameCategorylist = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/game/category/list`
//客服微信号
const customerWx = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/customer/wx`
//首页消息中心
const messageCentre = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/messageCentre/index`
//游戏详情
const gameDetail = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/game/detail`
//游戏推荐
const gameRecommend = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/gameRecommend/index`
//游戏评论提交
const gameComments = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/gameComments/index`
//详情页加关注
const detailsConcern = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/detailsConcern/index`
//游戏代金券
const gameCoupon = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/game/coupon`
//游戏公告列表
const gameNoticelist = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/game/notice/list`
//账号密码登录
const pwdLogin = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/account/pwd_login`
//注册发送短信验证码
const registerCode = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/common/send_code`
//手机验证码登录
const codeLogin = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/account/code_login`
//忘记密码
const forgetPwd = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/account/forget_pwd`
//公告内容
const getGameNotice = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/GameNotice/getGameNotice`
//活动列表
const activityList = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/game/activity/list`
//活动内容
const getGameActivity = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/GameActivity/getGameActivity`
//攻略内容
const getGameStrategy = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/GameStrategy/getGameStrategy`
//礼包列表
const giftList = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/game/gift/list`
//token登录
const tokenIndex = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/token/index`
//我的已关注列表
const userFocusGame = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/UserCentre/userFocusGame`
//我的正在玩列表
const userPlayedGame = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/UserCentre/playedGame`
//礼包领取
const giftGet = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/game/gift/get`
//礼包内容
const gameGift = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/game/gift`
//代金券领取
const couponGet = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/game/coupon/get`
//实名认证
const userBindID = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/user/bind/id`
//手机绑定
const userBindmobile = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/user/bind/mobile`
//用户充值记录
const userPayRecord = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/user/payRecord`
//支付方式
const payWay = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/user/payWay`
//平台币充值
const pay = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/user/recharge`
//手机验证
const verifyBindMobile = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/user/verify/bindMobile`
//手机绑定
const bindMobile = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/user/bind/mobile`
//手机换绑
const unbindMobile = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/user/unbind/mobile`
//充值列表我的游戏
const userGameList = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/user/gameList`
//我的礼包
const myGift = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/user/myGift`
//初始化
const h5Init = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/h5Init/begin`
//支付订单查询
const paySelect = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/user/paySelect`
//建议反馈图片上传
const suggestUpload = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/game/suggest_upload`
//建议反馈提交
const gameSuggest = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/game/suggest`
//子账号登录
const zzhLogin = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/account/uname_login`
//创建普通账号
const addSub = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/account/addSub`
//下载验证
const yzCode = `https://sdkapi.dingdangyou.cn/api/v1/verificationCode/index`
//用户中心-我的优惠券
const myCoupon = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/user/myCoupon`
//游戏评论列表
const commentsList = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/game/gameComments/list`
//评论点赞
const commentDz = `${protocol}//boxapi.${name}.${suffix}/api/v1/box/game/comment/zan`



//评论点赞
const CommentDz = (data) => {
  return service.request({
    url: commentDz,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//游戏评论列表
const CommentsList = (data) => {
  return service.request({
    url: commentsList,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//我的优惠券
const MyCoupon = (data) => {
  return service.request({
    url: myCoupon,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//下载验证
const YzCode = (data) => {
  return service.request({
    url: yzCode,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}


//创建普通账号
const AddSub = (data) => {
  return service.request({
    url: addSub,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//子账号登录
const ZzhLogin = (data) => {
  return service.request({
    url: zzhLogin,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//建议反馈提交
const GameSuggest = (data) => {
  return service.request({
    url: gameSuggest,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//建议反馈图片上传
const SuggestUpload = (data) => {
  return service.request({
    url: suggestUpload,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//我的礼包
const PaySelect = (data) => {
  return service.request({
    url: paySelect,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//我的礼包
const H5Init = (data) => {
  return service.request({
    url: h5Init,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//我的礼包
const MyGift = (data) => {
  return service.request({
    url: myGift,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//手机换绑
const UnbindMobile = (data) => {
  return service.request({
    url: unbindMobile,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//充值列表我的游戏
const UserGameList = (data) => {
  return service.request({
    url: userGameList,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//手机绑定
const BindMobile = (data) => {
  return service.request({
    url: bindMobile,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//手机验证
const VerifyBindMobile = (data) => {
  return service.request({
    url: verifyBindMobile,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//支付方式
const Pay = (data) => {
  return service.request({
    url: pay,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//支付方式
const PayWay = (data) => {
  return service.request({
    url: payWay,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//用户充值记录
const UserPayRecord = (data) => {
  return service.request({
    url: userPayRecord,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//手机绑定
const UserBindmobile = (data) => {
  return service.request({
    url: userBindmobile,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//实名认证
const UserBindID = (data) => {
  return service.request({
    url: userBindID,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//代金券领取
const CouponGet = (data) => {
  return service.request({
    url: couponGet,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//礼包内容
const GameGift = (data) => {
  return service.request({
    url: gameGift,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//礼包领取
const GiftGet = (data) => {
  return service.request({
    url: giftGet,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//我的正在玩列表
const UserPlayedGame = (data) => {
  return service.request({
    url: userPlayedGame,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//我的已关注列表
const UserFocusGame = (data) => {
  return service.request({
    url: userFocusGame,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//活动内容
const TokenIndex = (data) => {
  return service.request({
    url: tokenIndex,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//活动内容
const GiftList = (data) => {
  return service.request({
    url: giftList,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//活动内容
const GetGameStrategy = (data) => {
  return service.request({
    url: getGameStrategy,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//活动内容
const GetGameActivity = (data) => {
  return service.request({
    url: getGameActivity,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}


//公告内容
const ActivityList = (data) => {
  return service.request({
    url: activityList,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//公告内容
const GetGameNotice = (data) => {
  return service.request({
    url: getGameNotice,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//忘记密码
const ForgetPwd = (data) => {
  return service.request({
    url: forgetPwd,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//手机验证码登录
const CodeLogin = (data) => {
  return service.request({
    url: codeLogin,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//游戏公告列表
const RegisterCode = (data) => {
  return service.request({
    url: registerCode,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//游戏公告列表
const PwdLogin = (data) => {
  return service.request({
    url: pwdLogin,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//游戏公告列表
const GameNoticelist = (data) => {
  return service.request({
    url: gameNoticelist,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//游戏代金券
const GameCoupon = (data) => {
  return service.request({
    url: gameCoupon,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//详情页加关注
const DetailsConcern = (data) => {
  return service.request({
    url: detailsConcern,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//游戏评论提交
const GameComments = (data) => {
  return service.request({
    url: gameComments,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//游戏详情
const GameRecommend = (data) => {
  return service.request({
    url: gameRecommend,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//游戏详情
const GameDetail = (data) => {
  return service.request({
    url: gameDetail,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//首页消息中心
const MessageCentre = (data) => {
  return service.request({
    url: messageCentre,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//客服微信号
const CustomerWx = (data) => {
  return service.request({
    url: customerWx,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//游戏大厅游戏列表
const GameCategorylist = (data) => {
  return service.request({
    url: gameCategorylist,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//游戏大厅游戏分类
const GameCategory = (data) => {
  return service.request({
    url: gameCategory,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}


//搜索
const HomeSearch = (data) => {
  return service.request({
    url: homeSearch,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//首页排行榜
const Leaderboard = (data) => {
  return service.request({
    url: leaderboard,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//首页精选和新游
const SelectedGame = (data) => {
  return service.request({
    url: selectedGame,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//首页tab栏
const BoxTabindex = (data) => {
  return service.request({
    url: boxTabindex,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//首页设备删除
const DeleteDevice = (data) => {
  return service.request({
    url: deleteDevice,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//首页设备开关
const DeviceOperation = (data) => {
  return service.request({
    url: deviceOperation,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//小号设备锁定
const DeviceLocking = (data) => {
  return service.request({
    url: deviceLocking,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//首页设备列表
const IndexdeviceList = (data) => {
  return service.request({
    url: indexdeviceList,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//设备登录
const Authorization = (data) => {
  return service.request({
    url: authorization,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//登录保护
const LoginProtection = (data) => {
  return service.request({
    url: loginProtection,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//发送验证码
const SendCode = (data) => {
  return service.request({
    url: sendCode,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//安全中心登录
const CenterLogin = (data) => {
  return service.request({
    url: centerLogin,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
    
  })
}

//设备列表
const DeviceList = (data) => {
  return service.request({
    url: deviceList,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data:qs.stringify(data)
  }).then(res=>{
    return res.data
  })
}




export default{
  SendCode,
  CenterLogin,
  DeviceList,
  LoginProtection,
  Authorization,
  IndexdeviceList,
  DeviceLocking,
  DeviceOperation,
  DeleteDevice,
  BoxTabindex,
  SelectedGame,
  Leaderboard,
  HomeSearch,
  GameCategorylist,
  GameCategory,
  CustomerWx,
  MessageCentre,
  GameDetail,
  GameRecommend,
  GameComments,
  DetailsConcern,
  GameCoupon,
  GameNoticelist,
  PwdLogin,
  RegisterCode,
  CodeLogin,
  ForgetPwd,
  GetGameNotice,
  ActivityList,
  GetGameActivity,
  GetGameStrategy,
  GiftList,
  TokenIndex,
  UserFocusGame,
  UserPlayedGame,
  GiftGet,
  GameGift,
  CouponGet,
  UserBindID,
  UserBindmobile,
  UserPayRecord,
  PayWay,
  Pay,
  VerifyBindMobile,
  BindMobile,
  UserGameList,
  UnbindMobile,
  MyGift,
  H5Init,
  PaySelect,
  SuggestUpload,
  GameSuggest,
  ZzhLogin,
  AddSub,
  YzCode,
  MyCoupon,
  CommentsList,
  CommentDz
}